import { toggleBodyClass } from "../../helpers";

export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const SET_RETURN_FOCUS = "SET_RETURN_FOCUS";

function toggleModalContainer(termsUrl) {
  return {
    type: TOGGLE_MODAL,
    termsUrl,
  };
}

export function setReturnFocus(returnFocus) {
  return {
    type: SET_RETURN_FOCUS,
    returnFocus,
  };
}

export function toggleModal(isActive, returnEl, termsUrl) {
  return (dispatch, getState) => {
    const {
      Modal: { returnFocus },
    } = getState();
    dispatch(toggleModalContainer(termsUrl));
    toggleBodyClass(isActive);
    window.scrollTo("body", 0);

    return isActive
      ? dispatch(setReturnFocus(returnEl))
      : returnFocus && returnFocus.focus();
  };
}
